'use client';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@eliadmin/core/src/components/ui/select';

import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type CategorySortProps = {
  className?: string;
};

export function CategorySortToggle(props: CategorySortProps) {
  const { t } = useTranslations();
  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <Select value={selectedValue} onValueChange={onSortChange}>
      <SelectTrigger
        aria-label="Zoradiť produkty"
        className={cn(
          'col-span-1 h-12 items-center justify-between rounded-none border border-border bg-transparent px-6 text-sm font-medium tracking-tighter sm:w-[210px] md:w-[300px] md:text-base lg:h-14',
          'ea-category-sort__select-trigger',
        )}
        innerTriggerClassName={cn('w-full p-0', 'ea-category-sort__select-trigger-inner')}
      >
        {t(VALUES.find(o => o.value === selectedValue)?.label || '')}
      </SelectTrigger>
      <SelectContent
        className={cn(
          'flex w-[210px] -translate-x-[25px] flex-col items-start justify-start gap-3 rounded-none border border-border bg-white !shadow-none sm:border-t-0 md:w-[300px]',
          'ea-category-sort__select-content',
        )}
      >
        {VALUES.map(o => (
          <SelectItem
            value={o.value}
            key={o.value}
            className={cn(
              ' rounded-none px-6 text-sm tracking-tighter md:text-base',
              'ea-category-sort__select-item',
            )}
          >
            {t(o.label)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default CategorySortToggle;
